module.exports = __webpack_public_path__ + "img/icon_paying.1cdca719.png";